<template>
  <b-icon
    v-if="working"
    icon="three-dots"
    animation="cylon"
    font-scale="4"
  ></b-icon>
</template>

<script>
import ServerLinks from "../config.js";
import axios from "axios";

export default {
  name: "UserCheck",
  data() {
    return {
      working: false
    };
  },
  mounted() {
    this.working = true;
    console.log("Checking User");

    let fdvc = new FormData();
    fdvc.append("checkuser", "checkuser");
    axios
      //.get(ServerLinks.CONTROLLER)
      .post(ServerLinks.LOGINCHECK, fdvc)
      .then(response => {
        let dt = response.data;
        if (dt != undefined && dt.code != undefined) {
          if (dt.code != 1) {
            //user NOT logged in
            console.log("User NOt Logged IN");
            location.replace("/secure/login.html");
            //
          } else {
            console.log("User OK");
          }
        }
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => (this.working = false));
  }
};
</script>
